import React, { lazy } from "react";
import { useModals } from "../../shared/hooks/useModals";
import DelayUnmount from "../DelayUnmount";
const ModalCreateDemography = lazy(() =>
  import("../ModalCreateCategorical/ModalCreateDemography")
);

export default function DemographyModals() {
  const { modalState, showModal, closeModal } = useModals();

  return (
    <>
      <DelayUnmount mount={modalState.createCategory.show}>
        <ModalCreateDemography
          open={modalState?.createCategory?.show}
          onClose={() => closeModal("createCategory")}
        />
      </DelayUnmount>
      <DelayUnmount mount={modalState.editCategory.show}>
        <ModalCreateDemography
          open={modalState?.editCategory?.show}
          onClose={() => {
            closeModal("editCategory");
          }}
          dataDemography={modalState.editCategory?.data}
          isEdit={true}
        />
      </DelayUnmount>
    </>
  );
}
